import { createApp } from 'vue'
import ViewEditor from './views/ViewEditor.vue'
import VueKonva from 'vue-konva';
import { createPinia } from 'pinia'

const pinia = createPinia()

const app = createApp(ViewEditor)

app
  .use(pinia)
  .use(VueKonva)
  .mount('#app')